import { render, staticRenderFns } from "./SearchLocationProductsCard.vue?vue&type=template&id=5ff27364&"
import script from "./SearchLocationProductsCard.vue?vue&type=script&lang=js&"
export * from "./SearchLocationProductsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports